import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation, useOutletContext } from 'react-router';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { GameModeType, selectCasinoTheme, setGameModeAction } from '../../features/casinotheme';
import { selectPlayer } from '../../features/player/playerSlice';
import '../../scss/casino-layout.scss';
import CasinoHeaderBar from './components/CasinoHeaderBar';
import PinnedMenu from './components/PinnedMenu';

const { Content, Footer, Sider, Header } = Layout;
const CasinoLayout = () => {
	const player = useAppSelector(selectPlayer);
	const [fullScreen, setFullScreen] = useState<boolean>(false);
	const [isInAWindow, setIsInAWindow] = useState<boolean>(false);
	const casinoTheme = useAppSelector(selectCasinoTheme);
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	useEffect(() => {
		window.addEventListener('resize', () => {
			if (window.innerHeight != window.screen.height) setFullScreen(false);
			else setFullScreen(true);
		});
	}, []);

	const openInWindowClick = () => {
		const w = window.open(
			'/#' + location.pathname + `?gameId=${casinoTheme.gameId.id}&gameProvider=${casinoTheme.gameId.provider}`,
			'_blank',
			'popup=yes,width=1024,height=768'
		);
		navigate(-1);
	};

	const fullScreenClick = () => {
		var elem = document.documentElement;
		elem.requestFullscreen();
	};

	return (
		<div className="casino-layout">
			{!fullScreen && !casinoTheme.isInAWindow && (
				<CasinoHeaderBar
					onModeChange={mode => dispatch(setGameModeAction(mode))}
					initialMode={casinoTheme.gameMode}
					onOpenInWindowClick={() => openInWindowClick()}
					onFullScreenClick={() => fullScreenClick()}
				/>
			)}
			<div className="casino-body">
				<Outlet />
				{/* {!fullScreen && !casinoTheme.isInAWindow && (
					<PinnedMenu
						onOpenInWindowClick={() => {
							const w = window.open(
								'/#' +
									location.pathname +
									`?gameId=${casinoTheme.gameId.id}&gameProvider=${casinoTheme.gameId.provider}`,
								'_blank',
								'popup=yes,width=1024,height=768'
							);
							navigate(-1);
						}}
						onFullScreenClick={() => {
							var elem = document.documentElement;
							elem.requestFullscreen();
						}}
					/>
				)} */}
			</div>
		</div>
	);
};

export default CasinoLayout;
